<template>
    <div>
        <v-alert 
            v-if="requires && requires.length > 0"
            text
            dense
            color="error"          
            icon="mdi-alert-outline"    
        >
            <span class="black--text mr-2">O sistema detectou a ausência de informações nas abas: </span>
            <span v-for="alert in requires" :key="alert.description">
                <v-chip
                    label
                    small
                    class="ma-1"
                    dark
                    color="red"
                    @click="changeTab(alert.tab)"
                >
                    <span style="font-size:12px">{{ alert.description }}</span>
                </v-chip>
            </span>
        </v-alert>

        <alert-component v-if="!can('Ativa imóvel da carteira') && localItem.status == 'Pendente'" :alert="alerts.active_property"></alert-component>

        <alert-component v-if="!can('Ativa imóvel da carteira') && localItem.status != 'Pendente'" :alert="alerts.change_property"></alert-component>
        
        <v-alert 
            v-if="user_requests.data && user_requests.data.length > 0"
            text
            dense
            color="orange"          
            icon="mdi-alert-outline"    
        >
            <span class="black--text mr-2">Solicitação de ativação registrada com status "Novo". Para registrar uma nova solicitação é necessário aguardar a conclusão da solicitação previamente registrada. Essa solicitação foi enviada para seu gerente .<br /> 
                <div class="mt-3">
                    <span class="font-weight-bold"> Solicitante: </span> {{ user_requests.data[0].name_user_request }} 
                    <span class="font-weight-bold ml-6"> Data da solicitação: </span> {{ formatDateTime(user_requests.data[0].created_at) }}
                </div>
            </span>
        </v-alert>
        
        <v-form ref="form">
            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-select
                        v-model="localItem.status"
                        :items="items.status"
                        :rules="[rules.required]"
                        outlined
                        dense
                        :class="$css_field"
                        :readonly="!can('Ativa imóvel da carteira')"
                        :filled="!can('Ativa imóvel da carteira')"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Status</span>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-menu
                        v-model="calendar.data_atualizacao"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            dense
                            outlined
                            v-model="localItem.data_atualizacao"
                            append-icon="mdi-calendar-range"
                            readonly
                            v-on="on"
                            :class="$css_field"
                            :rules="[rules.required]"
                        >
                            <template v-slot:label>
                                <span :class="$css_field">Data de Atualizaçāo Nova</span>
                            </template>
                        </v-text-field>
                        </template>

                        <v-date-picker locale="pt-br" v-model="data_atualizacao" @input="calendar.data_atualizacao = false"></v-date-picker>

                    </v-menu>
                </v-col>
                <v-col v-if="data_atualizacao_antiga && data_atualizacao_antiga != null" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-text-field
                        dense
                        outlined
                        v-model="data_atualizacao_antiga"
                        label="Data de Atualizaçāo Antiga"
                        append-icon="mdi-calendar-range"
                        readonly
                        filled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-textarea
                        v-model="localItem.obs_status"
                        outlined
                        dense
                        :class="$css_field"
                        :readonly="!can('Ativa imóvel da carteira')"
                        :filled="!can('Ativa imóvel da carteira')"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Obs status (opcional)</span>
                        </template>
                    </v-textarea>
                </v-col>
            </v-row>
            <v-row dense>    
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <v-btn
                        v-if="can('Excluir imóvel da carteira')"
                        dark
                        color="error"   
                        @click="confirmDestroy(localItem)"
                        :class="$css_button"
                        :block="$vuetify.breakpoint.smAndDown"
                    >
                        Excluir
                    </v-btn>
                </v-col>

                <v-col v-if="can('Ativa imóvel da carteira')" cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="text-right">
                    <v-btn
                        dark
                        color="primary"
                        @click="validate()"
                        :class="$css_button"
                        :block="$vuetify.breakpoint.smAndDown"
                    >
                        Gravar
                    </v-btn>
                </v-col>

                <v-col v-else cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="text-right">
                    <v-row>
                        <v-col cols="auto">
                            <v-btn
                                v-if="user_requests.data && user_requests.data.length == 0"
                                dark
                                color="primary"
                                @click="storeUserRequest()"
                                :class="$css_button"
                            >
                                SOLICITAR ATIVAÇÃO
                            </v-btn>
                        </v-col>

                        <v-col cols="auto">
                            <v-btn
                                dark
                                color="purple"
                                @click="openUserRequest()"
                                :class="$css_button"
                            >
                                SOLICITAR ALTERAÇÃO
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>    
            </v-row>
        </v-form>       
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

var moment = require('moment')
import { STATUS_PROPERTY_ITEMS, TIPO_IMOVEL_PROPERTY_ITEMS } from './config_properties/config_properties.js'
import AlertComponent from '@/components/alert/AlertComponent.vue'

export default {
    components: {
        AlertComponent
    },

    props: {
        object: {
            required: true,
            default: () => ({})
        },
    },

    watch: {
        object: {
            handler() {
                this.setObject()
            },
            deep: true, // Observa mudanças profundas
            immediate: true // Executa imediatamente ao montar
        },

        data_atualizacao () {
            this.localItem.data_atualizacao = this.formatDate(this.data_atualizacao)
        },
    },

    computed: {
        ...mapGetters('permissions', ['can'])
    },

    data () {
        return {
            localItem: {
                id: null,
                status: null,
                data_atualizacao: null,
                obs_status: null
            },

            requires: [],

            alerts: {
                active_property: {
                    type: 'error',
                    icon: 'mdi-alert-outline',
                    messages: ['Você nāo possui permissāo para alterar o status do imóvel. Clique no botão "Solicitar Ativação"']
                },

                change_property: {
                    type: 'error',
                    icon: 'mdi-alert-outline',
                    messages: ['Você nāo possui permissāo para alterar o status do imóvel. Clique no botão "Solicitar Alteração"']
                },
            },

            user_request: {
                model:'properties',
                item_id:'',
                subject:'Solicitação de ativação',
            },

            items: {
                status: STATUS_PROPERTY_ITEMS,
                tipo_imovel: TIPO_IMOVEL_PROPERTY_ITEMS
            },

            data_atualizacao: '',
            data_atualizacao_antiga: null,

            calendar: {
                data_atualizacao: false,
            },

            rules: {
                required: value => !!value || 'Obrigatório'
            },

            user_requests: {
                data:[]
            },

            params: {
                user_requests: {
                    model: 'properties',
                    item_id: '',
                    subject:'Solicitação de ativação',
                    status: 'Novo',
                    check_new: 'true'   
                }
            }
        }
    },

    methods: {
        setObject(){
            this.localItem.id = this.object.id;
            this.localItem.status = this.object.status;
            //this.localItem.data_atualizacao = this.object.data_atualizacao;
            this.localItem.obs_status = this.object.obs_status;
            this.data_atualizacao_antiga = this.object.data_atualizacao;

            //this.setDate();  
            this.filterTipoImovel(this.object.tipo_imovel);
            this.loadPromisseUserRequests();
        },

        validate () {
            if (this.$refs.form.validate()) {
                this.updatePropertyStatus(this.localItem)
            }
        },

        updatePropertyStatus(item){
            this.$store.dispatch('updatePropertyStatus', item)
                        .then(response => {
                            //this.localItem = response.data; 
                            this.$snotify.success('Cadastro com sucesso!');
                            if(this.localItem.status != 'Pendente'){
                                this.showItem(this.localItem.id);
                            }
                        })
                        .catch(error => {
                            console.log(error)
                            this.$snotify.error('Erro no cadastro')
                        });
                   
        }, 

        showItem(id){
            this.$router.push({
                name: 'admin.properties2.show',
                params: { uuid: id }
            });
        },

        setDate(){
            this.localItem.data_atualizacao = moment().format('DD/MM/YYYY');
        },

        filterTipoImovel(tipoImovel){
            this.items.tipo_imovel = this.items.tipo_imovel.filter(model => model.tipo == tipoImovel)
            if(this.items.tipo_imovel && this.items.tipo_imovel.length > 0){
                this.checkRequires(this.items.tipo_imovel[0])
            }
        },

        checkRequires(item){
            this.requires = []
            if(item.requires && item.requires.length > 0){
                item.requires.forEach(i => {
                    // type array
                    if(i.type === 'array'){
                        if(i.rule == 'greater_than_zero'){
                            if(this.object[i.field] <= 0){
                                const result = {}
                                result.description = i.description
                                result.tab = i.tab
                                this.requires.push(result)
                            }
                        }
                    }
                    // end array
                    // type string
                    if(i.type === 'string'){
                        // aba publicidade
                        if(i.field == 'publicidade'){
                            let require_publicidade = false
                            if(this.object['titulo_publicitario'] == '' || this.object['titulo_publicitario'] == null){
                                require_publicidade = true
                            }
                            if(this.object['texto_publicitario'] == '' || this.object['texto_publicitario'] == null){
                                require_publicidade = true
                            }

                            if(this.object['publicar_imovel'] == '' || this.object['publicar_imovel'] == null){
                                require_publicidade = true
                            }

                            if(require_publicidade == true){
                                const result = {}
                                result.description = i.description
                                result.tab = i.tab
                                this.requires.push(result)
                            }
                        }
                        // end aba publicidade
                    }
                    // end array
                })
            } 
        },

        storeUserRequest(){
            this.user_request.item_id = this.object.id
            
            this.$store.dispatch('storeUserRequest', this.user_request)
                        .then(response => {
                            this.$snotify.success('Solicitação enviada com sucesso! Aguarde a conclusão da solicitação junto ao seu gerente.')
                            this.loadPromisseUserRequests()
                        })
                        .catch(error => {
                            console.log(error)
                            this.$snotify.error('Erro no cadastro')
                        })
        },

        loadPromisseUserRequests(){
            this.params.user_requests.item_id = this.object.id
            this.$store.dispatch('loadPromisseUserRequest', this.params.user_requests )
                        .then(response => {
                           this.user_requests = response
                        })
            
        },

        changeTab(num){
            let tab = 'tab-' + num
            this.$emit('callChangeTab', tab)
        },

        openUserRequest(){
            this.$emit('callOpenUserRequest', 'user_requests');
        },
        
        confirmDestroy(item) {
            this.$snotify.warning(`Tem certeza que deseja excluir esse registro?`, 'Confirmaçāo', {
                timeout: 10000,
                showProgressBar: true,
                closeоnClick: true,
                buttons: [
                    {text: 'Nāo', action: this.$snotify.remove()},
                    {text: 'Sim', action: () => {
                        this.destroy(item)
                        this.$snotify.remove()
                    }},
                ]
            })
        },

        destroy(item){
            this.$store.dispatch('destroyProperty', item.id)
                        .then(() => {
                            this.propertyDeleted();
                        })
                        .catch(error => {
                            this.$snotify.error('error', error)
                        });
        },

        propertyDeleted(){
            this.$router.push({
                name: 'admin.properties2.deleted'
            });
        }
        
    }
}
</script>

<style scoped>

</style>